import { API } from '@/api';
import axios from 'axios';

export const uploadVideo = (data, signedURL, config) => {
  return axios({
    method: 'put',
    url: signedURL,
    data: data,
    headers: {
      'Content-type': 'application/octet-stream',
      // for Azure storage
      'Date': new Date().getUTCDate(),
      'x-ms-blob-type': 'BlockBlob',
    },
    onUploadProgress: config.onUploadProgress
  })
};

export const processVideo = (videoId) => API.post(`/videos/${videoId}/recreate/`);
export const updateVideo = (status, videoId) => API.put(`/videos/${videoId}/`, status);
export const getGcpSignedURL = (origin, filename, folder) => API.get(`/signed_url/?file_name=${filename}&origin=${origin}&parent_id=${folder}`);
export const getVideos = (skip = 0, limit = 20, filter = '') => API.get(`/videos/?video_name=${filter}&skip=${skip}&limit=${limit}&origin=${window.location.origin}`);
export const getVideoById = (videoId) => API.get(`/videos/${videoId}/`);
export const getAugmentedVideo = (videoId) => API.get(`/videos-analytics/${videoId}/`);
export const removeTag = (videoId, tag) => API.delete(`/videos-analytics/${videoId}/`, {data: tag});
export const deleteAugmentedVideo = (videoId) => API.delete(`/videos-analytics/${videoId}/`);
export const editAugumentedVideo = (videoId, updatedVideo) => API.put(`/videos-analytics/${videoId}/`, updatedVideo);
export const getSingleFrame = (videoId, frameId) => API.get(`/videos/${videoId}/frames/${frameId}/`);
export const getSingleFrameForVideoAnalytics = (videoId, frameId) => API.get(`/videos-analytics/${videoId}/frames/${frameId}/`);
export const getLazyFrame = (videoId, frameId) => API.get(`/videos/${videoId}/lazy_frames/${frameId}/`, { responseType: 'arraybuffer' });
export const getLazyFrameForVideoAnalytics = (videoId, frameId) => API.get(`/videos/${videoId}/lazy_frames/${frameId}/?is_scene=1`, { responseType: 'arraybuffer' });
export const deleteVideo = (videoId) => API.delete(`/videos/${videoId}/`);
export const reportIssue = (issue) => API.post('/feedbacks/', issue);
export const fetchSuggestionInFiles = (str) => API.get(`/suggestions_search/?value=${str}`);
